import { Button, ConfigProvider } from 'antd';
import React from 'react';
import { LightPalette, DarkPalette } from '../../config/colors';
import { useDarkModeValue } from '../../hooks/useDarkModeValue';

const Basic = ({
  disabled,
  icon,
  loading,
  shape,
  type,
  size,
  color,
  text,
  onClick,
  className,
  containerStyle,
  buttonStyle,
  ref,
  _sx,
  htmlType,
  ...props
}) => {
  // antd tokens are parsed by tinycolor, so they need literal colours rather
  // than the CSS custom properties used elsewhere.
  const { isDarkMode } = useDarkModeValue();
  const palette = isDarkMode ? DarkPalette : LightPalette;

  return (
    <div style={containerStyle}>
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: palette.accent,
            colorPrimaryHover: palette.accentStrong,
            colorPrimaryActive: palette.accentStrong,
            borderRadius: 11,
            controlHeight: 38,
            lineWidth: 1,
          },
        }}
      >
        <Button
          disabled={disabled}
          icon={icon}
          loading={loading}
          shape={shape}
          size={size} // 'small'| 'medium'| 'large'
          type={type}
          color={color}
          onClick={onClick}
          style={buttonStyle}
          className={className}
          ref={ref}
          {...props}
          htmlType={htmlType}
        >
          {text}
        </Button>
      </ConfigProvider>
    </div>
  );
};

export default Basic;
